import { render, staticRenderFns } from "./formXPItem1.vue?vue&type=template&id=1f1a7c9d"
import script from "./formXPItem1.vue?vue&type=script&lang=js"
export * from "./formXPItem1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports